import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { CloseButton } from "./auth-service-tools280.js";
const ComboboxClearButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    size,
    onMouseDown,
    onClick,
    onClear,
    ...others
  } = _ref;
  return /* @__PURE__ */jsxRuntimeExports.jsx(CloseButton, {
    ref,
    size: size || "sm",
    variant: "transparent",
    tabIndex: -1,
    "aria-hidden": true,
    ...others,
    onMouseDown: event => {
      event.preventDefault();
      onMouseDown == null ? void 0 : onMouseDown(event);
    },
    onClick: event => {
      onClear();
      onClick == null ? void 0 : onClick(event);
    }
  });
});
ComboboxClearButton.displayName = "@mantine/core/ComboboxClearButton";
export { ComboboxClearButton };